import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { UIError } from "./errors";

var PrivateDining = /*#__PURE__*/function () {
  function PrivateDining(config, axios) {
    _classCallCheck(this, PrivateDining);

    _defineProperty(this, "axios", void 0);

    _defineProperty(this, "config", void 0);

    this.axios = axios;
    this.config = config;
  }

  _createClass(PrivateDining, [{
    key: "requestPrivateDining",
    value: function () {
      var _requestPrivateDining = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(payload) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.axios.post(this.config.postfix.PRIVATE_DINING, payload).then(function (resp) {
                  var _resp$data;

                  if (resp !== null && resp !== void 0 && (_resp$data = resp.data) !== null && _resp$data !== void 0 && _resp$data.errors) {
                    var _resp$data2;

                    throw {
                      errors: resp === null || resp === void 0 ? void 0 : (_resp$data2 = resp.data) === null || _resp$data2 === void 0 ? void 0 : _resp$data2.errors
                    };
                  }

                  return resp.data;
                })["catch"](function (err) {
                  throw new UIError(err);
                });

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function requestPrivateDining(_x) {
        return _requestPrivateDining.apply(this, arguments);
      }

      return requestPrivateDining;
    }()
  }, {
    key: "getPrivateDiningRestuarants",
    value: function () {
      var _getPrivateDiningRestuarants = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.axios.get(this.config.postfix.SEARCH_RESTAURANTS_FOR_PRIVATE_DINING).then(function (resp) {
                  var _resp$data3;

                  return resp === null || resp === void 0 ? void 0 : (_resp$data3 = resp.data) === null || _resp$data3 === void 0 ? void 0 : _resp$data3.restaurants;
                })["catch"](function (err) {
                  throw new UIError(err);
                });

              case 2:
                return _context2.abrupt("return", _context2.sent);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getPrivateDiningRestuarants() {
        return _getPrivateDiningRestuarants.apply(this, arguments);
      }

      return getPrivateDiningRestuarants;
    }()
  }, {
    key: "requestGroupDining",
    value: function () {
      var _requestGroupDining = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(payload) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.axios.post(this.config.postfix.GROUP_DINING, payload).then(function (resp) {
                  var _resp$data4;

                  if (resp !== null && resp !== void 0 && (_resp$data4 = resp.data) !== null && _resp$data4 !== void 0 && _resp$data4.errors) {
                    var _resp$data5;

                    throw {
                      errors: resp === null || resp === void 0 ? void 0 : (_resp$data5 = resp.data) === null || _resp$data5 === void 0 ? void 0 : _resp$data5.errors
                    };
                  }

                  return resp.data;
                })["catch"](function (err) {
                  throw new UIError(err);
                });

              case 2:
                return _context3.abrupt("return", _context3.sent);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function requestGroupDining(_x2) {
        return _requestGroupDining.apply(this, arguments);
      }

      return requestGroupDining;
    }()
  }, {
    key: "fetchPageContent",
    value: function () {
      var _fetchPageContent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(contentIds, restaurantNum) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.axios.post(this.config.postfix.PRIVATE_DINING_CONTENT, {
                  contentIds: contentIds
                }, {
                  params: {
                    restaurantNum: restaurantNum
                  }
                }).then(function (resp) {
                  var _resp$data6;

                  return {
                    contentIds: resp === null || resp === void 0 ? void 0 : (_resp$data6 = resp.data) === null || _resp$data6 === void 0 ? void 0 : _resp$data6.contentIds
                  };
                })["catch"](function (err) {
                  throw new UIError(err);
                });

              case 2:
                return _context4.abrupt("return", _context4.sent);

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function fetchPageContent(_x3, _x4) {
        return _fetchPageContent.apply(this, arguments);
      }

      return fetchPageContent;
    }()
  }, {
    key: "fetchTimeSLotsForSelectedDate",
    value: function () {
      var _fetchTimeSLotsForSelectedDate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(restaurantNumber, rdpDate) {
        var _this$axios$get, _this$axios$get$then;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return (_this$axios$get = this.axios.get(this.config.postfix.RESTAURANT_DETAILS_WITH_RDP_DATE, {
                  params: {
                    restaurantNumber: restaurantNumber,
                    rdpDate: rdpDate
                  }
                })) === null || _this$axios$get === void 0 ? void 0 : (_this$axios$get$then = _this$axios$get.then(function (response) {
                  var _response$data;

                  return response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.restaurant;
                })) === null || _this$axios$get$then === void 0 ? void 0 : _this$axios$get$then["catch"](function (err) {
                  throw new UIError(err);
                });

              case 2:
                return _context5.abrupt("return", _context5.sent);

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function fetchTimeSLotsForSelectedDate(_x5, _x6) {
        return _fetchTimeSLotsForSelectedDate.apply(this, arguments);
      }

      return fetchTimeSLotsForSelectedDate;
    }()
  }]);

  return PrivateDining;
}();

export { PrivateDining as default };